<template>
    <v-dialog
        v-if="dialogReview"
        v-model="dialogReview"
        persistent
        scrollable
        :overlay-color="overlay_color"
        :overlay-opacity="overlay_opacity"
        max-width="410px"
    >
        <v-card>
            <v-card-title width="100%">
                Preview
                <v-spacer></v-spacer>
                <v-btn small icon @click="closeDialog()">
                    <v-icon>mdi-close-circle</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text
                v-if="!view_soal"
                class="mt-5"
                style="min-height: 250px"
            >
                <div
                    v-if="tryout.subtests"
                    v-for="(data, index) of tryout.subtests"
                    :key="index"
                    class="box-mapel mb-4"
                    @click="selectMapelBundle(data.subject_name)"
                >
                    <v-row>
                        <v-col cols="2" md="2">
                            <v-avatar>
                                <v-img
                                    :src="
                                        data.subject_picture
                                            ? data.subject_picture
                                            : '@/assets/blank.svg'
                                    "
                                    :style="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'background-size:20px'
                                            : ''
                                    "
                                ></v-img>
                            </v-avatar>
                        </v-col>
                        <v-col
                            cols="8"
                            md="8"
                            class="pl-4"
                            style="align-self: center !important"
                        >
                            <span
                                class="montserrat-text darkblue--text font-weight-600"
                            >
                                {{ data.subject_name }}
                            </span>
                        </v-col>
                        <v-col
                            cols="2"
                            md="2"
                            class="pl-5"
                            style="align-self: center !important"
                        >
                            <v-icon color="blew"
                                >mdi-chevron-right-circle</v-icon
                            >
                        </v-col>
                    </v-row>
                </div>

                <div v-if="!tryout.subtests.length" class="mb-4">
                    <v-btn depressed disabled block>
                        Tidak ada substests soal
                    </v-btn>
                </div>
            </v-card-text>

            <v-card-text v-if="view_soal" class="pa-0" width="100%">
                <v-card flat color="#f3f5f7" class="py-2">
                    <v-card flat class="ma-0 mb-2 px-5 py-2 d-flex">
                        <v-btn
                            depressed
                            fab
                            class="btn-rounded"
                            color="#e8f5fa"
                            @click="view_soal = false"
                        >
                            <v-icon color="#1976d2">mdi-chevron-left</v-icon>
                        </v-btn>

                        <div v-if="subject_name && view_soal" class="ml-4 pt-1">
                            <div>Subject</div>
                            <div class="blew--text">
                                <b>{{ subject_name }}</b>
                            </div>
                        </div>

                        <!-- <v-btn
              depressed
              fab
              class="btn-rounded ml-1"
              color="#e8f5fa"
              @click="changeMode()"
            >
              <v-icon color="#1976d2">mdi-laptop</v-icon>
            </v-btn> -->
                    </v-card>
                    <v-card v-if="item_soal.wacana" flat class="ma-0 mb-2">
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title
                                    class="text-body-2 black--text"
                                >
                                    <div
                                        class="font-weight-bold black--text pa-0 mb-5"
                                        style="font-size: 16px"
                                    >
                                        Wacana
                                    </div>

                                    <p
                                        v-if="!!item_soal.wacana"
                                        style="white-space: pre-line"
                                        v-html="parseLatex(item_soal.wacana)"
                                    ></p>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                    <v-card flat class="mx-0 mb-2">
                        <v-list-item two-line>
                            <v-list-item-content>
                                <div
                                    class="font-weight-600 mb-5"
                                    style="font-size: 16px"
                                >
                                    Soal Nomor {{ item_soal.sequence }}
                                </div>

                                <div
                                    class="text-body-2 black--text"
                                    style="white-space: pre-line"
                                    v-html="parseLatex(item_soal.soal)"
                                ></div>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                    <v-card
                        v-if="
                            item_soal.tipe_pilihan === 'single' ||
                            item_soal.tipe_pilihan === 'multiple'
                        "
                        flat
                        class="mx-0 mt-2 pb-5"
                    >
                        <v-list>
                            <v-list-item
                                two-line
                                style="min-height: none !important"
                            >
                                <v-list-item-content>
                                    <v-list-item-subtitle
                                        class="font-weight-bold black--text pa-0"
                                        style="font-size: 16px"
                                    >
                                        Pilihan Jawaban
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-card
                                v-for="(jawaban, i) in item_soal.pilihan"
                                :key="i"
                                v-show="jawaban.value"
                                elevation="0"
                                class="mx-4 mb-3 py-1"
                                color="#f4f9f9"
                            >
                                <div
                                    cols="1"
                                    class="pa-2 d-flex align-center"
                                    :class="
                                        keySoal[i] == true
                                            ? 'bg-success text-white'
                                            : 'black60--text'
                                    "
                                >
                                    <span
                                        class="text-subtitle-1 font-weight-bold px-2"
                                    >
                                        {{ jawaban.key }}
                                    </span>
                                    <div
                                        v-html="parseLatex(jawaban.value)"
                                    ></div>
                                </div>
                                <!-- <div cols="1" class="pa-2 d-flex align-center">
                  <span class="text-subtitle-1 font-weight-bold px-2">
                    <v-btn
                      depressed
                      fab
                      color="#e8f5fb"
                      x-small
                      class="blew--text font-weight-500"
                      style="font-size: 18px"
                    >
                      {{ jawaban.key }}
                    </v-btn>
                  </span>
                  <div
                    class="ml-2 darkblue--text"
                    v-html="parseLatex(jawaban.value)"
                  ></div>
                </div> -->
                            </v-card>
                        </v-list>
                    </v-card>

                    <div
                        class="mx-4 my-2 mb-4"
                        v-if="item_soal.tipe_pilihan === 'truefalse'"
                    >
                        <table width="100%" cellpadding="10">
                            <tr style="background-color: #f3f5f7">
                                <td width="60%" class="pa-3">Pernyataan</td>
                                <td class="pa-3" align="center">Benar</td>
                                <td class="pa-3" align="center">Salah</td>
                            </tr>
                            <tr
                                v-for="(jawaban, i) in item_soal.pilihan"
                                :key="i"
                                v-show="jawaban.value"
                                style="border-top: 1px solid #ebebeb"
                            >
                                <td class="pa-3" width="40%">
                                    <div
                                        v-html="parseLatex(jawaban.value)"
                                    ></div>
                                </td>
                                <td
                                    class="pa-3 text-center"
                                    :class="
                                        keySoal[i] == true
                                            ? 'bg-success text-white'
                                            : 'bg-error'
                                    "
                                >
                                    <v-icon
                                        v-if="keySoal[i]"
                                        color="white"
                                        style="font-size: 20px"
                                    >
                                        mdi-check-circle
                                    </v-icon>
                                </td>

                                <td
                                    class="pa-3 text-center"
                                    :class="
                                        !keySoal[i]
                                            ? 'bg-success text-white'
                                            : 'bg-error'
                                    "
                                >
                                    <v-icon
                                        v-if="!keySoal[i]"
                                        color="white"
                                        style="font-size: 20px"
                                    >
                                        mdi-check-circle
                                    </v-icon>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <v-card
                        v-if="item_soal.tipe_pilihan === 'inputtext'"
                        flat
                        class="mx-0 my-2"
                    >
                        <v-list>
                            <v-list-item
                                two-line
                                style="min-height: none !important"
                            >
                                <v-list-item-content>
                                    <v-list-item-subtitle
                                        class="font-weight-bold black--text pa-0"
                                    >
                                        Jawaban
                                    </v-list-item-subtitle>
                                    <div
                                        v-html="parseLatex(key_soal.key)"
                                    ></div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-card>
                <v-card flat class="mx-0 mb-2">
                    <v-list-item two-line>
                        <v-list-item-content>
                            <div
                                class="font-weight-600 mb-5"
                                style="font-size: 16px"
                            >
                                Pembahasan
                            </div>

                            <div
                                class="text-body-2 black--text"
                                style="white-space: pre-line"
                                v-html="parseLatex(key_soal.explanation)"
                            ></div>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
            </v-card-text>
            <v-card-actions
                v-if="view_soal"
                style="display: grid; justify-content: center"
            >
                <div class="pa-2 d-flex align-center text-center">
                    <v-btn
                        depressed
                        fab
                        color="blew"
                        small
                        @click="pageStep('prev')"
                        :disabled="current_page === 1"
                    >
                        <v-icon color="#fff">mdi-chevron-left</v-icon>
                    </v-btn>

                    <div
                        class="mx-2 grey--text font-weight-600"
                        style="font-size: 18px"
                    >
                        <span>{{ current_page }}</span
                        >/<span>{{ item_subtests_count }}</span>
                    </div>

                    <v-btn
                        depressed
                        fab
                        color="blew"
                        small
                        @click="pageStep('next')"
                        :disabled="current_page === item_subtests_count"
                    >
                        <v-icon color="#fff">mdi-chevron-right</v-icon>
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Spinner from "@/modules/global/components/plugins/Spinner";
import katex from "katex";
import showdown from "showdown";
import TryoutService from "@/modules/tryout/services/tryout.js";

export default {
    name: "preview-soal",
    components: {
        "app-spinner": Spinner,
    },
    props: ["dialogReview", "data"],
    data: function () {
        return {
            isLoading: false,
            dialogReview: true,
            data_preview: null,
            tryout: {},
            bundleCode: null,
            keyBundleCode: null,
            code: null,
            item_soal: null,
            key_soal: null,
            view_soal: false,
            subject_name: null,
            subtests: null,
            item_subtests_count: 0,
            current_page: 1,
            mode: false,
            overlay_color: "#f3f5f7",
            overlay_opacity: 1,
            keySoal: null,
        };
    },

    computed: {
        dialogState: {
            get() {
                return this.dialogReview;
            },
            set() {
                this.$emit("closeDialog");
            },
        },
    },

    mounted() {
        this.getDetailTryout();
    },

    watch: {
        overlay_color: function (val) {
            this.overlay_opacity = 0.7;
        },
    },

    methods: {
        closeDialog() {
            this.$emit("closeDialog");
        },

        getDetailTryout() {
            var context = this;
            TryoutService.getTryoutById(context.data.id, function (result) {
                if (result.success) {
                    context.tryout = result.data;
                    context.code = context.data.code;
                    context.getBundleTryout();
                    context.getBundleKeyTryout();
                }
            });
        },

        parseLatex: function (content) {
            var converter = new showdown.Converter();

            var compiledContent = content.replace(/&gt;/g, ">");
            compiledContent = compiledContent.replace(/&lt;/g, "<");
            compiledContent = compiledContent.replace(/&amp;/g, "&");

            compiledContent = this.compileInlineLatex(compiledContent);
            compiledContent = this.compileBlockLatex(compiledContent);

            return converter.makeHtml(compiledContent);
        },

        compileInlineLatex: function (content) {
            var pattern = /\\\\\((.*?)\\\\\)/g;
            var compiledContent = content;
            var match;

            // eslint-disable-next-line
            while ((match = pattern.exec(compiledContent))) {
                var index = match.index;
                var length = match[0].length;
                var formula = katex.renderToString(match[1], { trust: true });
                compiledContent =
                    compiledContent.substr(0, index) +
                    formula +
                    compiledContent.substr(index + length);
            }

            return compiledContent;
        },

        compileBlockLatex: function (content) {
            var pattern = /\$\$(.*?)\$\$/g;
            var compiledContent = content;
            var match;

            // eslint-disable-next-line
            while ((match = pattern.exec(compiledContent))) {
                var index = match.index;
                var length = match[0].length;
                var formula =
                    '<p class="text-center">' +
                    katex.renderToString(match[1], { trust: true }) +
                    "</p>";
                compiledContent =
                    compiledContent.substr(0, index) +
                    formula +
                    compiledContent.substr(index + length);
            }
            return compiledContent;
        },

        async getBundleTryout() {
            const url = `/bundles/${this.code}/${this.code}_01001_${this.tryout.category}.json`;

            try {
                await this.$alioss.get(url).then((response) => {
                    const parsed = JSON.parse(response.res.data);
                    this.bundleCode = parsed;
                });
            } catch (error) {
                console.log("error bundle", error);
            }
        },

        async getBundleKeyTryout() {
            const url = `/bundles/${this.code}/keys/KEY_${this.code}_01001_${this.tryout.category}.json`;

            try {
                await this.$alioss.get(url).then((response) => {
                    const parsed = JSON.parse(response.res.data);
                    this.keyBundleCode = parsed;
                });
            } catch (error) {
                this.$store.commit("showAlert", {
                    message: `Tidak dapat membuka soal tryout`,
                    submessage: `Bundle soal tidak tersedia di OSS`,
                    type: "error",
                });
            }
        },

        selectMapelBundle(val) {
            this.view_soal = true;
            this.current_page = 1;

            if (!this.bundleCode) {
                this.$store.commit("showAlert", {
                    message: `Tidak dapat membuka soal tryout`,
                    submessage: `Bundle soal tidak tersedia di OSS`,
                    type: "error",
                });
                return false;
            }

            var subtests = this.bundleCode.subtests.find(
                (s) => s.subject_name === val
            );

            const items = subtests && subtests.items ? subtests.items : [];

            this.subtests = subtests;
            this.item_subtests_count = items.length;
            this.subject_name = subtests ? subtests.subject_name : "";
            this.item_soal = items.find((s) => s.sequence === 1) || null;

            if (!this.item_soal) {
                this.view_soal = false;
                this.$store.commit("showAlert", {
                    message: `Tidak dapat membuka soal tryout`,
                    submessage: `Soal untuk mapel "${val}" tidak ditemukan di bundle`,
                    type: "error",
                });
                return false;
            }

            this.key_soal = this.keyBundleCode.find(
                (s) => s.item_code === this.item_soal.item_code
            );

            this.keySoal = [
                this.item_soal.st_pilihan_1,
                this.item_soal.st_pilihan_2,
                this.item_soal.st_pilihan_3,
                this.item_soal.st_pilihan_4,
                this.item_soal.st_pilihan_5,
            ];
        },

        pageStep(type) {
            if (type === "next") {
                this.current_page = this.current_page + 1;
            } else {
                this.current_page = this.current_page - 1;
            }

            const nextItem = this.subtests.items.find(
                (s) => s.sequence === this.current_page
            );

            if (!nextItem) {
                this.$store.commit("showAlert", {
                    message: `Soal tidak ditemukan`,
                    submessage: `Sequence ${this.current_page} tidak ada di bundle`,
                    type: "error",
                });
                return;
            }

            this.item_soal = nextItem;
            this.key_soal = this.keyBundleCode.find(
                (s) => s.item_code === this.item_soal.item_code
            );
            this.keySoal = [
                this.item_soal.st_pilihan_1,
                this.item_soal.st_pilihan_2,
                this.item_soal.st_pilihan_3,
                this.item_soal.st_pilihan_4,
                this.item_soal.st_pilihan_5,
            ];
        },

        changeMode() {
            var self = this;
            self.overlay_color = "blue";
        },
    },
};
</script>

<style>
.box-mapel {
    border: 1.5px solid #e4e4e4 !important;
    border-radius: 5px;
    cursor: pointer;
    padding: 20px;
    align-self: center !important;
}

.box-mapel:hover {
    border: 1.5px solid #56b4e6 !important;
    color: #2690cb !important;
}
</style>

<style>
.bg-success {
    background-color: #00cf3f !important;
}
.bg-error {
    background-color: #ff9f9e !important;
}
</style>



// WEBPACK FOOTER //
// PreviewSoal.vue?05ca64ee